import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select'
import axios from 'axios'
import MapPicker from '../components/Map'
import IconContainer from '../components/IconContainer'
import SweetAlert from 'react-bootstrap-sweetalert'

const CurbIT = () => {
  const navigate = useNavigate();
  // States
  const [formData, setFormData] = useState({
    isClaimed: false,
    description: '',
    location: {
      lat: 0,
      lng: 0
    },
    tags: [],
    dataUrl: '',
    category: '',
    creator: localStorage.getItem('userId')
  })
  const [tagData, setTagData] = useState([])
  const [userLocation, setUserLocation] = useState({
    lat: 40.7468733,
    lng: -73.9947449
  })
  const [userSelectedLocation, setUserSelectedLocation] = useState({
    lat: 0,
    lng: 0
  })

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const { description, location, category, tags, } = formData

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleTagChange = selectedOptions => {
    const selectedTags = selectedOptions.map(option => option.value);
    setFormData({ ...formData, tags: selectedTags });
  };

  const handleCurrentLocationClick = () => {
    setFormData({ ...formData, location: userLocation });
  };

  const [dataUrl, setDataUrl] = useState('')
  const uploadImageHandler = (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
          setDataUrl(e.target.result);
          const getFormData = formData;
          getFormData.dataUrl = e.target.result;
          setFormData(getFormData);
          console.log(formData.dataUrl)
      };
      try {
          reader.readAsDataURL(file)
      } catch(error) {
          console.error(error);
      }

  };

  useEffect(() => {
    const getTags = async () => {
      try {
        const res = await axios.get('https://curb-it-backend-91f194a5e08f.herokuapp.com/tags');
        const formattedOptions = res.data[0].tags.map(tag => ({
          value: tag,
          label: tag
        }));
        setTagData(formattedOptions);
      } catch (err) {
        console.log(err);
      }
    };

    getTags();
  }, []);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function (position) {
      setUserLocation({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      })
    })
  }, [])


  useEffect(() => {
    setFormData({
      ...formData,
      location: {
        lat: userSelectedLocation.lat,
        lng: userSelectedLocation.lng
      }
    });
  }, [userSelectedLocation]);


  const handleSubmit = async e => {
    e.preventDefault()
    try {
      const res = await axios.post('https://curb-it-backend-91f194a5e08f.herokuapp.com/listing', formData)
      if (res.data.status === 200) {
        setShowSuccessAlert(true);
      } else {
        console.log('fail')
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div>
      <div className=" py-8 mb-16">
          <div className=" mx-auto bg-white p-6 rounded-lg shadow-md">
          <h1 className="text-xl mb-4 text-center font-orbit">What did you find?</h1>
          <IconContainer context="create-listing" setFormData={setFormData} formData={formData} />
          <h1 className="text-xl mt-4 mb-4 text-center font-orbit">Where is it?</h1>
          <p onClick={handleCurrentLocationClick} className="text-tahiti-500 cursor-pointer mb-4">
            Use my current location
          </p>
          <MapPicker location={userLocation} setLocation={setUserSelectedLocation} />
          <h1 className="text-xl mb-4 mt-8 text-center font-orbit">Tell Us More!</h1>
          <textarea
            name="description"
            placeholder="What does it look like? Is it in good condition?..."
            value={description}
            onChange={handleChange}
            rows="4"
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-tahiti-500 mb-4"
          />
           <h1 className="text-xl mt-4 mb-4 text-center font-orbit">Add some tags...</h1>
          <Select
            isMulti
            name="tags"
            options={tagData}
            className="basic-multi-select mb-4"
            classNamePrefix="select"
            onChange={handleTagChange}
          />
          <h1 className="text-xl mt-8 mb-8 text-center font-orbit">Got a photo?</h1>
          <div className="image-upload">
            <div className="image-container mb-4">
              <input type="file" id="myFile" accept="image/*" onChange={(event) => uploadImageHandler(event)} />
            </div>
            <img src={dataUrl} />
          </div>
          <h1 className="text-xl mt-8 mb-8 text-center font-orbit">Ready to CurbIT?</h1>
          <button
            className=" bg-tahiti-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-midnight focus:outline-none focus:bg-midnight mx-auto"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
      {showSuccessAlert && (
        <SweetAlert
          success
          title="Success!"
          onConfirm={() => {
            setShowSuccessAlert(false);
            navigate('/home');
          }}
        >
          Your item has been listed successfully.
        </SweetAlert>
      )}
    </div>
  );
};


export default CurbIT

